<template>
    <!-- 资源-产品管理 -->
    <div class="productManage">
        <!-- 标题 -->
        <div class="titleBox flex-row ite-c">
            <b>{{topTitle.title}}</b>
            <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
            <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
        </div>

        <!-- 筛选条件 -->
        <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
            <template slot="otherCom">

                <el-form-item>
                    <el-input
                            v-model="searchForm.id"
                            placeholder="输入产品ID"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.name"
                            placeholder="输入产品名称"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-select  v-model="searchForm.operator_id"
                                placeholder="选择运营商"
                                clearable filterable>
                        <el-option  v-for="item in operateOptions" 
                                    :key="item.id" 
                                    :label="item.name"
                                    :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select  v-model="searchForm.busi_code"
                                placeholder="选择业务类型"
                                clearable filterable>
                        <el-option  v-for="item in busiOptions" 
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                        ></el-option>
                    </el-select>
                </el-form-item>

            </template>
        </sr-filter>

        <!-- 表格 -->
        <div class="botTable boxs tableTheadGray">
            <div class="tableTop">
                <span class="top_le">产品列表</span>
                <span class="top_ri">
                    <button class="butStyle addBtn" @click="addProduct" v-if="loginUser.memberId == 'SUPER'">
                        <i class="el-icon-plus" style="margin-right:6px;"></i>
                        <span>添加产品</span>
                    </button>
                    <button class="butStyle pinkBtn exportBtn" @click="tableExport">
                        <i class="exportIcon"></i>
                        <span>导出</span>
                    </button>
                </span>
            </div>
            <el-table :data="tableData"
                        style="width: 100%;"
                        border
                        fit
                        highlight-current-row
                        tooltip-effect="dark"
            >
                <el-table-column label="产品" prop="productName" min-width="500" header-align="center" align="left"
                                show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="detailArea flex_h_hL_vC">
                            <img :src="$variable.getFile(scope.row.pic_id)" alt="" class="detailImg boxs">
                            <div class="detailInfo">
                                <p class="detailTit">{{scope.row.name}}</p>
                                <p class="detailBusi">业务：<span>{{scope.row.busi_name}}</span></p>
                                <p class="detailBusi">ID：<span>{{scope.row.id}}</span></p>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="产品运营商" prop="operator_name" min-width="140" header-align="center" align="center"
                                show-overflow-tooltip></el-table-column>
                
                <el-table-column label="价格" prop="price" min-width="170" header-align="center" align="center"
                                show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="orangeTextCurr=" style="font-size: 14px;">
                            ￥{{scope.row.price}}
                        </div>
                    </template>
                </el-table-column>
               
                <el-table-column label="创建人/时间" prop="create_member_name" min-width="170" header-align="center" align="center"
                                show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="flex_v_hC_vC" style="font-size: 14px;">
                            <p class="greenTextCurr">{{scope.row.create_member_name}}</p>
                            <p class="grayTextCurr">{{scope.row.create_time}}</p>
                        </div>
                    </template>
                </el-table-column>
               
                <el-table-column label="状态" prop="status_sale" width="140" header-align="center" align="center"
                                show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status_sale"
                            active-color="#76C819"
                            inactive-color="#FA6241"
                            :active-value="0"
                            :inactive-value="1"
                            active-text="上架"
                            inactive-text="下架"
                            @change="changeSaleStatus(scope)">
                        </el-switch>
                    </template>
                </el-table-column>
                
                <el-table-column label="操作" fixed="right" width="170" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button 
                                    @click="editProduct(scope)"
                                    class="greenTextCurr"
                                    icon="fa fa-pencil" type="text"
                                    title="编辑"
                                    v-if="loginUser.memberId == 'SUPER'"
                        >编辑</el-button>
                        <el-button
                                @click="editProduct(scope)"
                                class="greenTextCurr"
                                icon="fa fa-eye" type="text"
                                title="查看"
                                v-else
                        >查看</el-button>
                        <el-button v-if="loginUser.memberId == 'SUPER' && scope.row.status == '0' "
                                    @click="showDelDialog(scope)" 
                                    class="orangeTextCurr"
                                    icon="fa fa-trash" type="text" 
                                    title="删除"
                        >删除</el-button>
                        
                    </template>
                </el-table-column>

            </el-table>

            <div class="pageBox boxs">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="searchForm.page" :page-sizes="[10, 20, 30]" 
                            :page-size="searchForm.rows"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
    import SrFilter from '@/components/Common/Filter/Filter';
    import {objectToQueryString} from '@/utils/commonUtils.js';
    import {getLoginUser} from "@/service/authentication/authentication";
    import {
        getProductListReq, // 获取产品列表
        changeSaleStatus, // 改变上下架状态
        getBusiReq, // 获取业务类型
        changeStatus // 删除产品
    } from '@/api/Resource/productManage.js';

    // 搜索表格的条件
    const searchConst = {
        id: null, // 输入产品ID
        name: null, // 输入产品名称
        operator_id: null, // 选择运营商
        busi_code: null, // 选择业务类型
        page: 1, // 当前页码
        rows: 10, // 每页条数
    }

    export default {
        name: "productManageIndex",
        data() {
            return {
                timeRange: null,
                // 标题
                topTitle: {
                    title: '产品管理',
                    subTit: '',
                    thirdTit: '',
                },
                // 表格搜索条件
                searchForm: Object.assign({}, searchConst),
                // 运营商
                operateOptions: [],
                // 业务类型
                busiOptions: [],

                // 表格数据
                tableData: [],
                // 表格数据总数
                total: 0,
                loginUser: null
            }
        },
        components: {
            SrFilter
        },
        created() {
            this.loginUser = getLoginUser();

            // 获取列表数据
            this.getProductList();
            // 获取运营商类型
            this.initOperateOption();
            // 获取业务类型
            this.initBusiOption();
        },
        methods: {
            // 导出
            tableExport() {
                const url = `${this.$baseNewUrl}esaleb-service-resource/core-product/listExport?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm)}`;
                window.open(url, '_blank');
            },
            
            // 获取列表数据
            async getProductList() {
                try {
                    const resp = await getProductListReq(this.searchForm);
                    this.tableData = resp.data.records;
                    this.total = parseInt(resp.data.total)
                } catch (e) {
                    console.log(e)
                }
            },
            // 获取运营商类型
            async initOperateOption() {
                try {
                    // const resp = await getOperateReq()
                    // this.operateOptions = resp.data
                    this.operateOptions = [
                        { id: 'CU', name:'中国联通' },
                        { id: 'CN', name:'中国电信' },
                        { id: 'CM', name:'中国移动' },
                    ]
                } catch (e) {
                    console.log(e)
                }
            },
            // 获取业务类型
            async initBusiOption() {
                try {
                    const resp = await getBusiReq({table: "CORE_PRODUCT", field: "BUSI_CODE"});
                    this.busiOptions = resp.data
                } catch (e) {
                    console.log(e)
                }
            },

            // 列表过滤查询
            handleSearch() {
                this.getProductList()
            },
            // 搜索重置（清空）
            handleReset() {
                // 初始化参数
                this.searchForm = Object.assign({}, searchConst)
            },
            // 列表每页条数变了
            handleSizeChange(val) {
                this.searchForm.rows = val
                this.getProductList()
            },
            // 列表当前页码变了
            handleCurrentChange(val) {
                this.searchForm.page = val
                this.getProductList()
            },
            //改变上下架状态
            changeSaleStatus(scope) {
                let old = scope.row.status_sale == 0 ? 1 : 0;
                changeSaleStatus({id: scope.row.id, saleStatus: scope.row.status_sale}).then((resp => {
                    if(resp.code != 0 || resp.data != 1)
                        scope.row.status_sale = old;

                    if(resp.code != 0) {
                        this.$message.error(resp.msg);
                    }
                })).catch(e => {
                    console.error(e);
                    scope.row.status_sale = old;
                });
            },


            // 跳转到添加产品页面
            addProduct() {
                this.$router.push('productAdd')
            },
            // 编辑产品
            editProduct(data) {
                this.$router.push({
                    path: 'productEdit',
                    query: {
                        id: data.row.id
                    }
                })
            },
            // 弹出“删除”确认框
            showDelDialog(data) {
                var delParams = {
                    id: data.row.id,
                    status: 1
                };
                let $this = this;
                this.$confirm('删除产品将无法恢复，确定操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    $this.delProduct(delParams, '删除成功！')
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除操作'
                    })
                })
            },
            // 删除产品
            async delProduct(params, msg) {
                try {
                    console.log('delProduct',params);
                    const resp = await changeStatus(params);
                    if (resp && resp.code != 0) {
                        this.$message.error(resp.msg);
                        return
                    }
                    this.$message.success(msg);
                    this.getProductList()
                } catch (e) {
                    console.log(e)
                }
            },
            // 重置表单
            resetData() {
                this.$nextTick(() => {
                    this.$refs['form'].clearValidate()
                })
                this.postForm = Object.assign({}, defaultPostForm)
            }

        },


    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.greenTextCurr {
    color: #2DBAA5;
}
.orangeTextCurr {
    color: #FA6241;
}
.grayTextCurr {
    color: #B7B2AF;
}

.productManage {

}

// 标题
.productManage .titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleBox b {
    color: #2B2727;
    font-size: 15px;
}

.titleBox span {
    color: #7F7F7F;
    font-size: 13px;
}

.titleBox .titRiImg {
    width: 76px;
    height: 24px;
}

// 筛选框
.productManage .searchBox {
    margin-top: 1px;
}

// 表格
.productManage .botTable {
    margin-top: 12px;
    width: 100%;
}

.botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
}

.botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
}

.botTable .tableTop .top_ri {
    font-size: 12px;
    color: #4E4A46;
}

.botTable .tableTop .top_ri b {
    font-size: 20px;
    font-weight: normal;
    color: #FFCC00;
}

.botTable .tableTop .top_ri .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
}

.botTable .tableTop .top_ri .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
}

.botTable .tableTop .top_ri .importBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;
    background-color: #2DBAA5;
    &:hover {
      background-color: rgb(126, 187, 178);
    }
}

.botTable .tableTop .top_ri .importBtn .importIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/resource/NumCardManage/importIcon.png') no-repeat;
    background-size: 14px 14px;
}

.addBtn {
    width: 96px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    border-radius: 4px;
    color: #ffffff;

    background-color: #2DBAA5;

    &:hover {
        background-color: rgb(115, 196, 183);
    }
}

// 表格
.botTable .detailArea {
    width: 100%;
}
.detailArea .detailImg {
    width: 88px !important;
    height: 88px !important;
    min-width: 88px;
    border: 1px solid #EEEEEE;
    background: #f9f9f9;
}
.detailArea .detailInfo {
    width: calc(100% - 88px - 8px);
    color: #999;
    margin-left: 8px;
    font-size: 14px;
}
.detailInfo .detailTit {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333333;
    margin-bottom: 24px;
}
.detailInfo .detailBusi {
    color: #B7B2AF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.detailInfo .detailBusi span {
    color: #333333;
}


/* 分页条 */
.pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
}




// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #FFFFFF;
    // background: #FA6241;
    // &:hover {
    //   background-color: rgb(247, 143, 120);
    // }
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}

// 弹窗按钮-上传按钮
.uploadBtn {
    font-size: 12px;
    color: #ffffff;
    border: none;
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}
.uploadTip {
//   display: inline;
    font-size: 12px;
    color: #AAAAAA;
    margin-left: 12px;
}
.uploadTemplate {
    display: inline;
    cursor: pointer;
    font-size: 12px;
    color: #2DBAA5;
    text-decoration: none;
}
.uploadTemplate :active {
    color: rgb(134, 189, 180);
}

</style>
